import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_7: FaireProductEntity = {
  token: "viverano-7",
  type: "product",
  name: "Cable Knit Home Throw Adult Blanket (100% Organic Cotton)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/4d9e4e139e62c4a09b8c8608f6097d385c9d35168d5916ba1554b399dea6f197.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 52,
  msrpDollars: 88,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["catalog_cat_throw-pillows"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
